import { Title } from '@solidjs/meta'
import { type Component, createEffect, onCleanup } from 'solid-js'
import QuoteForm from '~/layers/ui/admin/cotizaciones/QuoteForm'
import { setTrailOverride } from '~/stores/breadcrumb'

/**
 * Alta de una cotización. La edición vive en [id].tsx: el formulario es el
 * mismo, compartido en la capa.
 */
const NuevaCotizacionPage: Component = () => {
  // Miga de pan propia. Se limpia al salir de la página.
  createEffect(() => {
    setTrailOverride(['Cotizaciones', 'Nueva Cotización'])
  })
  onCleanup(() => setTrailOverride(null))

  return (
    <>
      <Title>Nueva Cotización | Florez Jaramillo</Title>

      <QuoteForm quote={() => null} />
    </>
  )
}

export default NuevaCotizacionPage
